// extracted by mini-css-extract-plugin
export default {"legendWrapper":"TicketsTreeMapLegend_legendWrapper__nfloO","itemWrapper":"TicketsTreeMapLegend_itemWrapper__BW6BQ","legendMarker":"TicketsTreeMapLegend_legendMarker__fiA5m"};